import React, { useEffect } from "react";
import { usePageController } from "../../store/PageController";
import { Alert, Box, Chip, Typography } from "@mui/material";
import { useUserStore } from "../../store/UserStore";
import Introduction from "./components/Introduction";
import Create from "./components/Create";
import Deployments from "./components/Deployment/Deployments";
import Documentation from "./components/Documentation/Documentation";
import { calculateTrialDaysLeft, convertDate } from "../../utils/commonFunc";
import { useNavigate } from "react-router-dom";

function ServerlessComputing() {
  const currentComponent = usePageController((state) => state.currentComponent);
  const setCurrentComponent = usePageController(
    (state) => state.setCurrentComponent
  );
  const navigate = useNavigate();

  const user = useUserStore((state) => state.user);

  
  useEffect(() => {
    //if (!user) {
    //  navigate("/login");
    //} else {
      setCurrentComponent("intro");
    //}
  }, []);
  
  

  return (
    <Box display={"flex"} gap={"1rem"} maxWidth={"1440px"}>
      {/* This is an empty box to put some graphics later on  */}

      {currentComponent === "intro" && <Introduction />}

      {/* This section loads Create Component */}

      {currentComponent === "create" && <Create />}

      {/* This section loads Deployment Component */}

      {currentComponent === "deployments" && <Deployments />}
      {currentComponent === "docs" && <Documentation />}
    </Box>
  );
}

export default ServerlessComputing;
